import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { PermissionsService } from '../../../services/permission.service';
import { ApiService } from '../../../services/api.service';
import { Router } from '@angular/router';
// import { ApiService } from '../../services/api.service';
// import { PermissionsService } from '../../services/permission.service';

@Component({
  selector: 'app-pil',
  standalone: false,
  templateUrl: './pil.component.html',
})
export class PILComponent implements OnInit, OnDestroy {
  title = 'PIL Table';
  showDialog: boolean = false;
  isUpdatedialog: boolean = false;
  submitting: boolean = false;
  systemForm: FormGroup;
  private subscriptions = new Subscription();
  system: any[] = []
  unitList: any[];
  

  // Filter properties
  selectedFilterType: string = 'year';
  selectedYear: string = '';
  selectedMonth: string = '';
  selectedDateRange: string = '';
  customStartDate: string = '';
  customEndDate: string = '';
  availableYears: number[] = [];
  filterType: string = 'year-month';

  currentUser = localStorage.getItem('user_id');
  selectedRange: string = '';

  startDate: string = '';
  endDate: string = '';

  systems: any[] = [];



  // Additional header buttons for data table
  additionalHeaderButtons = [
    {
      label: 'Export CSV',
      icon: 'pi pi-download',
      severity: 'success',
      outlined: true,
      action: 'exportCSV'
    },
    {
      label: 'Generate Report',
      icon: 'pi pi-file-pdf',
      severity: 'info',
      outlined: true,
      action: 'generateReport'
    }
  ];


  tableHeaderDefinition = [
    { label: 'Action', field: 'actions', sortable: false },
    { label: 'Ser No.', field: 'ser_no', sortable: true },
    { label: 'PIL No.', field: 'pil_no', sortable: true },
    { label: 'Ser in PILs', field: 'ser_in_pils' },
    // { label: 'Indicative Year', field: 'indicative_year',sortable: false },
    { label: 'Item Description', field: 'item_desc', sortable: true },
    { label: 'DRDO/ PA (specify if Pvt or PSU with name)', field: 'drdo_pa' },
    { label: 'Category & Developmental Process', field: 'category_process' },
    // { label: 'Approx Cost Of Items Imported (5–7 Yrs)', field: 'approx_cost_imported', headerClass: 'text-right' },
    {
      label: 'Qty & Value for Ordered in last 02 years from indigenious sources  prior notification of Positive	',
      headerClass: 'text-center bg-blue-50',
      children: [
        { label: 'Qty (Ordered last 02 years)', field: 'qty_ordered_prior', headerClass: 'bg-blue-50' },
        { label: 'Value (Ordered last 02 years)', field: 'value_ordered_prior', headerClass: 'bg-blue-50' },
      ]
    },
    {
      label: 'Qty & Value Ordered from date of Notification of PIL till date	',
      headerClass: 'text-center bg-green-50',
      children: [
        { label: 'Qty (Ordered from date of Notification)', field: 'qty_ordered_notification', headerClass: 'bg-green-50' },
        { label: 'Value (Ordered from date of Notification)', field: 'value_ordered_notification', headerClass: 'bg-green-50' },
      ]
    },
    {
      label: 'Qty & Value for which AoN has been accorded/ RFP has been issued post notification of PIL	',
      headerClass: 'text-center bg-orange-50',
      children: [
        { label: 'Qty (AoN & RFP Issued of PIL)', field: 'qty_aon_rfp', headerClass: 'bg-orange-50' },
        { label: 'Value(AoN & RFP Issued of PIL)', field: 'value_aon_rfp', headerClass: 'bg-orange-50' },
      ]
    },
    { label: 'Current Status', field: 'current_status' },
    {
      label: 'Approx Qty and Value which is likely to be processed in next 5 to 7 years, however AoN is yet to be processed	',
      headerClass: 'text-center bg-purple-50',
      children: [
        { label: 'Qty (Approx next 5 to 7 years)', field: 'approx_qty_future', headerClass: 'bg-purple-50' },
        { label: 'Value (Approx next 5 to 7 years)', field: 'approx_value_future', headerClass: 'bg-purple-50' },
      ]
    },
    { label: 'Supply/ Contract order Number with date', field: 'supply_order_no_date' },
    { label: 'Concern Dtes', field: 'concern_dtes' },
    { label: 'Remarks if any', field: 'remarks' },
    // { label: 'No. of items Indigenised as on date', field: 'no_items_indigenised' },
    { label: 'EDC Date', field: 'edc_date' },
    // { label: 'No. of items which indigenisation is under progress', field: 'no_items_in_progress' },
    { label: 'Stage of development (drop down menu)', field: 'development_stage' },
    // { label: 'Cost of imported items', field: 'cost_imported_items' },
    { label: 'Importing Country', field: 'importing_country' },
  ];
  defaultVisibleColumns = [
    'actions',
    'ser_no',
    'pil_no',
    'ser_in_pils',
    'indicative_year',
    'item_desc',
    'drdo_pa',
    'category_process',
    'approx_cost_imported',
    'qty_ordered_prior',
    'value_ordered_prior',
    'qty_ordered_notification',
    'value_ordered_notification',
    'qty_aon_rfp',
    'value_aon_rfp',
    'current_status',
    'approx_qty_future',
    'approx_value_future',
    'supply_order_no_date',
    'concern_dtes',
    'remarks',
    'edc_date',
    'development_stage',
    'cost_imported_items',
    'importing_country'
  ];

  columnVisibility: Record<string, boolean> = {};
  tableHeaderRows: any[][] = [];
  columnChooserList: { field: string; label: string }[] = [];
  showColumnDialog = false;
  headerRow: any;

  /** Get unit name by ID from unitList; returns 'N/A' if not found. */
  getUnitNameById(unitId: number | string | null | undefined): string {
    if (unitId == null || !this.unitList?.length) return 'N/A';
    const unitIdNum = typeof unitId === 'number' ? unitId : parseInt(unitId, 10);
    if (isNaN(unitIdNum)) return 'N/A';
    const unit = this.unitList.find((u: any) => u.id === unitIdNum);
    return unit?.name ?? 'N/A';
  }

  private setDefaultColumnVisibility() {
    this.tableHeaderDefinition.forEach(node => {
      if (node.children?.length) {
        node.children.forEach(child => {
          if (child.field) {
            this.columnVisibility[child.field] = this.defaultVisibleColumns.includes(child.field);
          }
        });
      } else if (node.field) {
        this.columnVisibility[node.field] = this.defaultVisibleColumns.includes(node.field);
      }
    });
  }

  private computeHeaderRows() {
    const topRow: any[] = [];
    const secondRow: any[] = [];

    this.tableHeaderDefinition.forEach(node => {
      if (node.children?.length) {
        const visibleChildren = node.children.filter(child => child.field && this.isColumnVisible(child.field));
        if (!visibleChildren.length) {
          return;
        }
        topRow.push({
          label: node.label,
          colspan: visibleChildren.length,
          headerClass: node.headerClass
        });
        visibleChildren.forEach(child => {
          secondRow.push({ ...child, rowspan: 1 });
        });
      } else if (node.field && this.isColumnVisible(node.field)) {
        topRow.push({ ...node, rowspan: 2 });
      }
    });

    this.tableHeaderRows = [topRow];
    if (secondRow.length) {
      this.tableHeaderRows.push(secondRow);
    }
  }

  private buildColumnChooserList() {
    const leaves: { field: string; label: string }[] = [];
    this.tableHeaderDefinition.forEach(node => {
      if (node.children?.length) {
        node.children.forEach(child => child.field && leaves.push({ field: child.field, label: child.label }));
      } else if (node.field) {
        leaves.push({ field: node.field, label: node.label });
      }
    });
    this.columnChooserList = leaves;
  }

  isColumnVisible(field?: string): boolean {
    if (!field) return false;
    return this.columnVisibility[field] !== false;
  }

  onColumnToggle(field: string, checked: boolean) {
    this.columnVisibility[field] = checked;
    this.computeHeaderRows();
  }

  resetColumnsToDefault() {
    this.setDefaultColumnVisibility();
    this.computeHeaderRows();
  }


  cols: any[] = [
    { field: 'ser_no', header: 'Ser No.', filterType: 'numeric', width: '90px', minWidth: '70px', maxWidth: '110px' },
    { field: 'pil_no', header: 'PIL No.', filterType: 'text', width: '110px', minWidth: '90px', maxWidth: '130px' },
    { field: 'ser_in_pils', header: 'Ser in PILs', filterType: 'numeric', width: '110px', minWidth: '90px', maxWidth: '130px' },

    { field: 'description', header: 'Description', filterType: 'text', width: '220px', minWidth: '180px', maxWidth: '260px' },

    { field: 'drdo_pa', header: 'DRDO/ PA (specify if Pvt or PSU with name)', filterType: 'text', width: '260px', minWidth: '220px', maxWidth: '320px' },

    { field: 'category_process', header: 'Category & Developmental Process', filterType: 'text', width: '260px', minWidth: '220px', maxWidth: '320px' },

    { field: 'approx_cost_5_7yrs', header: 'Approx cost of items imported in 5–7 years (Crs)', filterType: 'numeric', width: '180px', minWidth: '150px', maxWidth: '220px' },

    { field: 'imported_quantity_5_7yrs', header: 'Imported quantity in 5–7 years', filterType: 'numeric', width: '180px', minWidth: '150px', maxWidth: '220px' },

    { field: 'indigenised_till_now', header: 'No. of Items indigenised till now', filterType: 'numeric', width: '180px', minWidth: '150px', maxWidth: '220px' },

    { field: 'description_of_tech', header: 'Description of Technology', filterType: 'text', width: '240px', minWidth: '200px', maxWidth: '300px' },

    { field: 'no_of_components', header: 'No. of Components imported', filterType: 'numeric', width: '160px', minWidth: '130px', maxWidth: '200px' },

    { field: 'critical_components', header: 'Critical Components', filterType: 'text', width: '200px', minWidth: '160px', maxWidth: '240px' },

    { field: 'component_qty', header: 'Component Qty', filterType: 'numeric', width: '120px', minWidth: '100px', maxWidth: '150px' },

    { field: 'import_cost', header: 'Import Cost', filterType: 'numeric', width: '140px', minWidth: '120px', maxWidth: '180px' },

    { field: 'indigenisation_status', header: 'Status of Indigenisation', filterType: 'dropdown', width: '180px', minWidth: '150px', maxWidth: '220px' },

    { field: 'present_stage', header: 'Present Stage of Development', filterType: 'dropdown', width: '200px', minWidth: '160px', maxWidth: '240px' },

    { field: 'action_by', header: 'Action by', filterType: 'text', width: '140px', minWidth: '110px', maxWidth: '180px' },

    { field: 'target_date_completion', header: 'Target date of Completion', filterType: 'date', width: '160px', minWidth: '140px', maxWidth: '200px' },

    { field: 'pdc_for_prototype', header: 'PDC for Prototype', filterType: 'date', width: '160px', minWidth: '140px', maxWidth: '200px' },

    { field: 'under_progress_items', header: 'No. of items under progress', filterType: 'numeric', width: '180px', minWidth: '150px', maxWidth: '220px' },

    { field: 'development_stage', header: 'Stage of development', filterType: 'dropdown', width: '180px', minWidth: '150px', maxWidth: '220px' },

    { field: 'cost_imported_items', header: 'Cost of imported items', filterType: 'numeric', width: '160px', minWidth: '130px', maxWidth: '200px' },

    { field: 'importing_country', header: 'Importing Country', filterType: 'text', width: '160px', minWidth: '130px', maxWidth: '200px' }
  ];



  selectedsystem: any;
  systemSection: any;
  showDeleteDialog: boolean = false
  showPilPopup = false;
  pilForm!: FormGroup;
  constructor(private fb: FormBuilder, private api: ApiService, private messageService: MessageService, private permissionService: PermissionsService, private router: Router) { }

  ngOnInit(): void {
    this.initializeYears();
    this.getUnitList();
    this.getSystem();
    this.setDefaultColumnVisibility();
    this.buildColumnChooserList();
    this.computeHeaderRows();
     this.generateYears();

  const currentYear = new Date().getFullYear().toString();
  this.selectedYear = currentYear; // ✅ auto select current year

  // Optional: set filter type
  this.filterType = 'year-month';

  this.applyFilters();
  this.checkAccess();
    this.pilForm = this.fb.group({
      last_submission: ['', Validators.required],
      doi_remark: ['', Validators.required]
    });


    // New form structure for PIL API
    this.systemForm = this.fb.group({

      ser_no: [''],
      pil_no: [''],
      ser_in_pils: [''],
      item_desc: ['', Validators.required],
      indicative_year: ['', Validators.required],
      concern_dtes: ['', Validators.required],
      drdo_pa: [''],
      category_process: [''],
      approx_cost_imported: [''],
      quantity_ordered: [''],
      value_ordered: [''],
      value_notified: [''],
      aon_rfp_post_notification: [''],
      value_aon_rfp_post_notification: [''],
      approx_quantity_value_likely_processed: [''],
      approx_value_likely_processed: [''],
      supply_contract: [''],
      no_of_items_indigenised: [''],
      no_of_items_indigenisation_under_progress: [''],
      description_of_technology: [''],
      stage_of_development: [''],
      cost_of_imported_items: [''],
      item_name: [''],
      pil_number: [''],
      quantity: [''],
      amount: [''],
      nodal_directorate: [''],
      start_date: [''],
      cutoff_date: [''],
      stage: [''],


      qty_ordered_prior: [''],
      value_ordered_prior: [''],
      qty_ordered_notification: [''],
      value_ordered_notification: [''],
      qty_aon_rfp: [''],
      value_aon_rfp: [''],

      current_status: [''],
      approx_qty_future: [''],
      approx_value_future: [''],

      supply_order_no_date: [''],
      remarks: [''],

      no_items_indigenised: [''],
      edc_date: [''],
      no_items_in_progress: [''],
      development_stage: [''],
      cost_imported_items: [''],
      importing_country: ['']
    });
  }
  get isIndigenised(): boolean {
    return this.systemForm.get('current_status')?.value === 'Indigenised';
  }

  get isNotIndigenised(): boolean {
    return this.systemForm.get('current_status')?.value === 'Not Indigenised';
  }
  showMasterButtons = false;
checkAccess() {
  const unitId = sessionStorage.getItem('unit_id');
  const roleId = sessionStorage.getItem('user_role_id');

  this.showMasterButtons =
    (unitId === '8' && roleId === '9') ||
    (unitId === '1' && roleId === '6');

  console.log("unitId && roleId ", unitId, roleId);
}

 ngAfterViewInit() {
  setTimeout(() => {
    const icons = document.querySelectorAll('.pi-th-large');

    icons.forEach((el: any) => {
      const parentBtn = el.closest('button'); // get button

      if (parentBtn) {
        parentBtn.style.backgroundColor = 'transparent';
        parentBtn.style.border = 'none';
        parentBtn.style.boxShadow = 'none';
      }
    });
  }, 0);
}
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  totalRecords: number = 0;


  getSystem() {
    let url = `/transaction/pil/`;
    this.api.getAPI(url).subscribe({
      next: (res: any) => {
        if (res?.data) {
          this.system = res.data;     // EXACT ARRAY
        } else {
          this.system = [];
        }
      },
      error: (err) => {
        console.error('Error loading PIL data:', err);
        this.system = [];
      }
    });
  }

  selectedId: any = null;


  mode: any = 'create';
  openPopup(rowData: any, mode: 'view' | 'edit' | 'create') {
    this.mode = mode;


    if (mode === 'create') {
      this.selectedId = null;
      this.title = 'Create New PIL';
      this.systemForm.reset();
      this.systemForm.enable();
    }

    if (mode === 'view') {
      this.selectedId = rowData.id;
      this.title = 'View PIL Details';
      this.systemForm.patchValue({ ...rowData, concern_dtes: parseInt(rowData.concern_dtes) });
      this.systemForm.disable(); // disable in view mode
    }

    if (mode === 'edit') {
      this.selectedId = rowData.id;
      this.title = 'Edit PIL Details';
      this.systemForm.patchValue({ ...rowData, concern_dtes: parseInt(rowData.concern_dtes) });
      this.systemForm.enable(); // editable
    }

    this.showDialog = true;
  }





  addSystem() {
    this.systemForm.reset();
    this.systemForm.enable()
    this.title = 'Create New PIL';
    this.showDialog = true;

  }

  currentPilRowData: any;
  displayDialog: boolean = false;
  onSubmitadd() {
    if (!this.systemForm.valid) return;
    if (this.submitting) return;

    this.submitting = true;
    const payload: any = {
      action: 'create',
      start_date: new Date().toISOString().split('T')[0],
      ser_no: this.systemForm.value.ser_no,
      pil_no: this.systemForm.value.pil_no,
      ser_in_pils: this.systemForm.value.ser_in_pils,
      item_desc: this.systemForm.value.item_desc,
      indicative_year: this.systemForm.value.indicative_year,
      concern_dtes: this.systemForm.value.concern_dtes,
      drdo_pa: this.systemForm.value.drdo_pa,
      category_process: this.systemForm.value.category_process,
      approx_cost_imported: this.systemForm.value.approx_cost_imported,

      qty_ordered_prior: this.systemForm.value.qty_ordered_prior,
      value_ordered_prior: this.systemForm.value.value_ordered_prior,
      qty_ordered_notification: this.systemForm.value.qty_ordered_notification,
      value_ordered_notification: this.systemForm.value.value_ordered_notification,

      qty_aon_rfp: this.systemForm.value.qty_aon_rfp,
      value_aon_rfp: this.systemForm.value.value_aon_rfp,

      current_status: this.systemForm.value.current_status,

      approx_qty_future: this.systemForm.value.approx_qty_future,
      approx_value_future: this.systemForm.value.approx_value_future,

      supply_order_no_date: this.systemForm.value.supply_order_no_date,
      remarks: this.systemForm.value.remarks,

      no_items_indigenised: this.systemForm.value.no_items_indigenised,
      edc_date: this.systemForm.value.edc_date,
      no_items_in_progress: this.systemForm.value.no_items_in_progress,

      development_stage: this.systemForm.value.development_stage,
      cost_imported_items: this.systemForm.value.cost_imported_items,
      importing_country: this.systemForm.value.importing_country
    };

    // ADD ID FOR UPDATE
    if (this.mode === 'edit' && this.selectedId) {
      payload.action = 'update';
      payload.id = this.selectedId;
    }


    const sub = this.api.postAPI('/transaction/pil/', payload).subscribe({
      next: (res: any) => {
        this.submitting = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: this.mode === 'edit' ? 'Updated successfully' : 'Created successfully'
        });

        this.showDialog = false;
        this.systemForm.reset();
        this.getSystem();
        this.currentPilRowData = res;
        // this.displayDialog = true;
      },
      error: () => {
        this.submitting = false;
      }
    });

    this.subscriptions.add(sub);
  }



  // Original viewSystem method (commented out)
  /*
  viewSystem(rowData: any) {
    this.viewMode = true;
     if (rowData && rowData.id) {
        this.selectedsystem = rowData;
        this.isUpdatedialog = true
        this.systemForm.patchValue({
          item_name: rowData.item_name,
          pil_number: rowData.pil_number,
          quantity: rowData.quantity,
          status: rowData.status,
          amount: rowData.amount,
          nodal_directorate: rowData.nodal_directorate,
          start_date: rowData.start_date,
          cutoff_date: rowData.cutoff_date,
          stage: rowData.stage,
          step: rowData.step,
          last_updated: rowData.last_updated,
          remarks: rowData.remarks,
        });
        this.systemForm.disable()
      }
  }
  */

  // New viewSystem method for PIL API
  viewMode = false;
  viewSystem(rowData: any) {
    this.viewMode = true;
    if (rowData && rowData.id) {
      this.selectedsystem = rowData;
      this.isUpdatedialog = true
      this.systemForm.patchValue({
        item_name: rowData.item_name,
        pil_number: rowData.pil_number,
        quantity: rowData.quantity,
        amount: rowData.amount,
        nodal_directorate: rowData.nodal_directorate_id || rowData.nodal_directorate, // Handle both ID and text values
        start_date: rowData.start_date,
        cutoff_date: rowData.cutoff_date,
        stage: rowData.stage,
        last_updated: rowData.last_updated,
        remarks: rowData.remarks,
      });
      this.systemForm.disable()
    }
  }
  updateSystem(equipment: any): void {
    this.viewMode = false;
    this.systemForm.enable()
    this.isUpdatedialog = true
    this.selectedsystem = equipment; // Store selected equipment
    this.systemForm.patchValue({
      item_name: equipment.item_name,
      pil_number: equipment.pil_number,
      quantity: equipment.quantity,
      amount: equipment.amount,
      nodal_directorate: equipment.nodal_directorate_id || equipment.nodal_directorate, // Handle both ID and text values
      start_date: equipment.start_date,
      cutoff_date: equipment.cutoff_date,
      stage: equipment.stage,
      last_updated: equipment.last_updated,
      remarks: equipment.remarks,
    })
  }

  onSubmitEq() {
    let sectionId = this.selectedsystem.id
    let payload = {
      item_name: this.systemForm.get('item_name')?.value,
      pil_number: this.systemForm.get('pil_number')?.value,
      quantity: this.systemForm.get('quantity')?.value,
      amount: this.systemForm.get('amount')?.value,
      nodal_directorated: this.systemForm.get('nodal_directorate')?.value, // This will now be the unit ID
      start_date: this.systemForm.get('start_date')?.value,
      cut_off_date: this.systemForm.get('cutoff_date')?.value,
      stage: this.systemForm.get('stage')?.value,
      last_updated_date: this.systemForm.get('last_updated')?.value || new Date().toISOString().split('T')[0],
      remark: this.systemForm.get('remarks')?.value,
    }

    console.log('Updating PIL with ID:', sectionId);
    console.log('Update payload:', payload);
    console.log('API endpoint:', `/transaction/pil/${sectionId}/`);

    const sub = this.api.putAPI(`/transaction/pil/${sectionId}/`, payload).subscribe({
      next: (res: any) => {
        console.log('Update response:', res);
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'PIL updated successfully'
        });
        this.isUpdatedialog = false;
        this.systemForm.reset();
        this.getSystem()
      },
      error: (error: any) => {
        console.error('Update error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.detail || 'Failed to update PIL'
        });
      }
    });
    this.subscriptions.add(sub);
    this.isUpdatedialog = false; // Close the popup
  }

  /**
   * @param id - The ID of the PIL record to update
   * @param data - The data object containing the fields to update
   */


  showDeletePopup(equipment: any) {
    this.showDeleteDialog = true;
    this.selectedsystem = equipment
  }
  deleteSystem(row: any) {
    if (!row?.id) {
      console.error("No ID found for delete");
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Invalid record.'
      });
      return;
    }

    const url = `/transaction/pil/`;
    let payload = {
      action: 'delete',
      id: row.id
    }
    this.api.deleteAPI(url).subscribe({
      next: (res) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Deleted',
          detail: 'Record deleted successfully'
        });

        // Remove from table instantly
        this.system = this.system.filter(item => item.id !== row.id);
      },
      error: (err) => {
        console.error("Delete error:", err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete record'
        });
      }
    });
  }

  //  confirmDelete(row: any) {
  //   this.selectedsystem = row;
  //   this.showDeleteDialog = true;
  // }
  confirmDelete(rowData: any) {
    this.selectedId = rowData.id;
    this.showDeleteDialog = true;
  }


  // performDelete() {
  //   this.showDeleteDialog = false;
  //   this.deleteSystem(this.selectedsystem);
  // }
  performDelete() {
    const payload = {
      id: this.selectedId,
      action: 'delete'
    };

    const sub = this.api.postAPI('/transaction/pil/', payload).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Deleted',
          detail: 'Record deleted successfully'
        });
        this.showDeleteDialog = false;
        this.getSystem();
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err.detail || 'Delete failed'
        });
      }
    });

    this.subscriptions.add(sub);
  }


  // New deleteSystem method for PIL API
  deleteRow() {
    let sectionId = this.selectedsystem?.id
    console.log('Deleting PIL with ID:', sectionId);
    console.log('API endpoint:', `/transaction/pil/${sectionId}/`);

    const sub = this.api.deleteAPI(`/transaction/pil/${sectionId}/`).subscribe({
      next: (res: any) => {
        console.log('Delete response:', res);
        this.showDeleteDialog = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'PIL Deleted Successfully',
        });
        this.getSystem()
      },
      error: (error: any) => {
        console.error('Delete error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.detail || 'Failed to delete PIL record'
        });
      },
    });
    this.subscriptions.add(sub);
  }
  get canEditSetup(): boolean {
    return this.permissionService.hasPrivilege('/master/rop', 'Edit') ||
      this.permissionService.hasPrivilege('/master/rop', 'Delete') ||
      this.permissionService.hasPrivilege('/master/rop', 'View');
  }

  // Load dummy data for testing - COMMENTED OUT TO USE API DATA
  /*
  loadDummyData(): void {
    console.log('Loading dummy data...');
    this.system = [
      {
        id: 1,
        item_name: 'Advanced Radar System',
        pil_number: 'PIL-2024-001',
        quantity: 5,
        status: 'In Progress',
        amount: 2500000.00,
        nodal_directorate: 'Electronics & Communication',
        start_date: '2024-01-15',
        cutoff_date: '2024-12-31',
        stage: 'Prototype',
        step: 'Testing Phase',
        last_updated: '2024-03-15',
        remarks: 'Critical project for defense modernization. Currently in prototype testing phase.'
      }
    ];
    this.totalRecords = 1;
    console.log('Dummy data loaded:', this.system);
    console.log('Total records:', this.totalRecords);
  }
  */

  // Initialize available years (current year and previous 10 years)
  initializeYears(): void {
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < 11; i++) {
      this.availableYears.push(currentYear - i);
    }
  }

  // Set filter type
  // setFilterType(type: string): void {
  //   this.selectedFilterType = type;
  //   this.selectedYear = '';
  //   this.selectedMonth = '';
  //   this.selectedDateRange = '';
  //   this.customStartDate = '';
  //   this.customEndDate = '';
  //   this.applyFilters();
  // }

  // Clear individual filters
  clearYear(): void {
    this.selectedYear = '';
    this.applyFilters();
  }

  clearMonth(): void {
    this.selectedMonth = '';
    this.applyFilters();
  }

  clearDateRange(): void {
    this.selectedDateRange = '';
    this.applyFilters();
  }

  clearCustomDate(): void {
    this.customStartDate = '';
    this.customEndDate = '';
    this.applyFilters();
  }

  // Get max date (today)
  getMaxDate(): string {
    return new Date().toISOString().split('T')[0];
  }

  // Get min date (10 years ago)
  getMinDate(): string {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 10);
    return date.toISOString().split('T')[0];
  }

  // Format date range for display
  formatDateRange(startDate: string, endDate: string): string {
    if (!startDate || !endDate) return '';
    const start = new Date(startDate);
    const end = new Date(endDate);
    return `${start.toLocaleDateString()} - ${end.toLocaleDateString()}`;
  }

  // Apply filters and refresh data
  // applyFilters(): void {
  //   console.log('Applying filters...', {
  //     filterType: this.selectedFilterType,
  //     year: this.selectedYear,
  //     month: this.selectedMonth,
  //     dateRange: this.selectedDateRange,
  //     customStartDate: this.customStartDate,
  //     customEndDate: this.customEndDate
  //   });
  //   // this.getSystem({ page: 1 });
  // }

  // Clear all filters
  clearFilters(): void {
    this.selectedYear = '';
    this.selectedMonth = '';
    this.selectedDateRange = '';
    this.customStartDate = '';
    this.customEndDate = '';
    this.selectedFilterType = 'year';
    // this.getSystem({ page: 1 });
  }

  // Download CSV functionality
  downloadCSV(): void {
    if (!this.system || this.system.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No Data',
        detail: 'No data available to export'
      });
      return;
    }

    // Define CSV headers matching the table columns
    const headers = [
      'Ser No.',
      'PIL No.',
      'Ser in PILs',
      'Description',
      'DRDO / PA',
      'Category & Process',
      'Import Cost (5-7 Yrs)',
      'Ordered Last 2 Years - Qty',
      'Ordered Last 2 Years - Value',
      'Post PIL Notification - Qty',
      'Post PIL Notification - Value',
      'AoN / RFP - Qty',
      'AoN / RFP - Value',
      'Current Status',
      'Future Pipeline - Qty',
      'Future Pipeline - Value',
      'Contract Details',
      'Concerned Directorate',
      'Remarks',
      'Items Indigenised',
      'EDC Date',
      'Items in Progress',
      'Development Stage',
      'Import Cost',
      'Importing Country'
    ];

    // Map data fields to headers
    const csvRows = [headers.join(',')];

    this.system.forEach((row: any) => {
      const values = [
        this.escapeCSV(row.ser_no || ''),
        this.escapeCSV(row.pil_no || ''),
        this.escapeCSV(row.ser_in_pils || ''),
        this.escapeCSV(row.item_desc || ''),
        this.escapeCSV(row.indicative_year || ''),
        this.escapeCSV(row.drdo_pa || ''),
        this.escapeCSV(row.category_process || ''),
        this.escapeCSV(row.approx_cost_imported || ''),
        this.escapeCSV(row.qty_ordered_prior || ''),
        this.escapeCSV(row.value_ordered_prior || ''),
        this.escapeCSV(row.qty_ordered_notification || ''),
        this.escapeCSV(row.value_ordered_notification || ''),
        this.escapeCSV(row.qty_aon_rfp || ''),
        this.escapeCSV(row.value_aon_rfp || ''),
        this.escapeCSV(row.current_status || ''),
        this.escapeCSV(row.approx_qty_future || ''),
        this.escapeCSV(row.approx_value_future || ''),
        this.escapeCSV(row.supply_order_no_date || ''),
        this.escapeCSV(row.concern_dtes || ''),
        this.escapeCSV(row.remarks || ''),
        this.escapeCSV(row.no_items_indigenised || ''),
        this.escapeCSV(row.edc_date || ''),
        this.escapeCSV(row.no_items_in_progress || ''),
        this.escapeCSV(row.development_stage || ''),
        this.escapeCSV(row.cost_imported_items || ''),
        this.escapeCSV(row.importing_country || '')
      ];
      csvRows.push(values.join(','));
    });

    // Create CSV content
    const csvContent = csvRows.join('\n');

    // Create blob and download
    const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    // Generate filename with timestamp
    const timestamp = new Date().toISOString().split('T')[0];
    const filename = `PIL_Items_Status_Report_${timestamp}.csv`;

    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    this.messageService.add({
      severity: 'success',
      summary: 'Export Successful',
      detail: `CSV file downloaded: ${filename}`
    });
  }

  // Helper method to escape CSV values
  private escapeCSV(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }

    const stringValue = String(value);

    // If value contains comma, quote, or newline, wrap in quotes and escape quotes
    if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
      return `"${stringValue.replace(/"/g, '""')}"`;
    }

    return stringValue;
  }

  // Generate report functionality
  generateReport(): void {
    console.log('Generating report...');
    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: 'Report generation functionality will be implemented'
    });
  }

  // Handle additional header button clicks
  onAdditionalButtonClick(action: string): void {
    switch (action) {
      case 'exportCSV':
        this.downloadCSV();
        break;
      case 'generateReport':
        this.generateReport();
        break;
      default:
        console.log('Unknown action:', action);
    }
  }

  // Helper method to get month name
  getMonthName(monthValue: string): string {
    const month = this.months.find((m: any) => m.value === monthValue);
    return month ? month.name : monthValue;
  }

  // Helper method to get date range label
  getDateRangeLabel(range: string): string {
    const labels: { [key: string]: string } = {
      'last-month': 'Last Month',
      'quarter': 'Quarter (3 Months)',
      'six-monthly': 'Six Monthly',
      'yearly': 'Yearly',
      'last-two-years': 'Last Two Years'
    };
    return labels[range] || range;
  }


  months = [
    { name: 'January', value: 1 },
    { name: 'February', value: 2 },
    { name: 'March', value: 3 },
    { name: 'April', value: 4 },
    { name: 'May', value: 5 },
    { name: 'June', value: 6 },
    { name: 'July', value: 7 },
    { name: 'August', value: 8 },
    { name: 'September', value: 9 },
    { name: 'October', value: 10 },
    { name: 'November', value: 11 },
    { name: 'December', value: 12 }
  ];

  // selectedYear: any = '';
  // selectedMonth: any = '';
  // selectedRange: any = '';
  // startDate: any = '';
  // endDate: any = '';

  setFilterType(type: string) {
    this.filterType = type;
    this.clearAll();
  }
  keyword: string = '';
  

  
years: string[] = [];
 generateYears() {
  const currentYear = new Date().getFullYear();

  this.years = Array.from({ length: 11 }, (_, i) =>
    (currentYear - i).toString()
  );
}


  applyFilters() {
    let url = '/transaction/pil/?';

    // YEAR-MONTH
    if (this.filterType === 'year-month') {
      if (this.selectedYear) url += `year=${this.selectedYear}&`;
      if (this.selectedMonth) url += `month=${this.selectedMonth}&`;
    }

    // RANGE FILTER
    if (this.filterType === 'range' && this.selectedRange) {
      url += `range_type=${this.selectedRange}&`;
    }

    // CUSTOM DATE FILTER
    if (this.filterType === 'custom') {
      if (this.startDate) url += `start_date=${this.startDate}&`;
      if (this.endDate) url += `end_date=${this.endDate}&`;
    }
    // ⭐ Correct keyword search for API: ?search=VALUE
    if (this.keyword && this.keyword.trim() !== '') {
      url += `search=${this.keyword.trim()}&`;
    }

    // NOTHING SELECTED → Load all
    if (url === '/transaction/pil/?') {
      this.getSystem();
      return;
    }

    // CLEAN TRAILING & OR ?
    url = url.replace(/[&?]$/, '');

    this.api.getAPI(url).subscribe({
      next: (res: any) => this.system = res?.data || [],
      error: () => this.system = []
    });
  }



  // applyFilters() {
  //   console.log("APPLY FILTER →", {
  //     year: this.selectedYear,
  //     month: this.selectedMonth,
  //     range: this.selectedRange,
  //     start: this.startDate,
  //     end: this.endDate
  //   });
  // }

  hasActiveFilter() {
    return this.selectedYear || this.selectedMonth || this.selectedRange || (this.startDate && this.endDate);
  }

  clearAll() {
    this.selectedYear = '';
    this.selectedMonth = '';
    this.selectedRange = '';
    this.startDate = '';
    this.endDate = '';
    this.getSystem();
  }

  // clearYear() { this.selectedYear = ''; }
  // clearMonth() { this.selectedMonth = ''; }
  clearRange() { this.selectedRange = ''; }
  clearCustom() { this.startDate = ''; this.endDate = ''; }

  getMonthLabel(val: any) {
    return this.months.find(m => m.value == val)?.name;
  }

  getRangeLabel(range: string) {
    const labels: any = {
      "last-month": "Last Month",
      "quarter": "Quarter (3 Months)",
      "six-months": "6 Months",
      "yearly": "Yearly",
      "two-years": "Last 2 Years"
    };
    return labels[range];
  }

  configurePIL(event: any) {
    this.router.navigate(['pil/transaction'], { queryParams: { id: event.id, step: event.id } });
  }
  onNeedformSubmit(event: any) {
    this.displayDialog = false;
    const routePayload: any = {
      pil: this.currentPilRowData?.id,
      remark: event.internalComment,
      is_external: event.shareType === 'external',
    };
    if (event.shareType === 'external') {
      routePayload.unit_id = event.selectedUnit?.id;
      routePayload.command = event.selectedCommand;
    } else {
      routePayload.user = event.selectedUser?.id;
    }
    this.api.postAPI('/file_mange/pil/editor/add/', routePayload).subscribe((res: any) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: res.message || 'PIL editor assigned successfully'
      });
      this.displayDialog = false;
      this.configurePIL(this.currentPilRowData)
    })
  }

  getUnitList() {
    this.api.getAPI('/master/units/').subscribe((res: any) => {
      this.unitList = res.data;
    })
  }
  submitPilUpdate() {

    if (this.pilForm.invalid) return;

    this.submitting = true;

    const formValue = this.pilForm.value;

    const pilList = this.system
      .filter((pil: any) => pil.file_status === 'initiated')
      .map((pil: any) => {
        return {
          pil: pil.id,
          pil_id: pil.id,
          is_external: true,
          is_final_editor: false,
          doi_remark: formValue.doi_remark ,
          unit_id: parseInt(pil.concern_dtes),
          last_submission: formValue.last_submission   // ✅ NEW FIELD
        };
      });

    this.api.postAPI('/transaction/pil/editor/update/', pilList)
      .subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || 'Sent for PIL Update Successfully'
          });

          this.showPilPopup = false;   // ✅ CLOSE POPUP
          this.pilForm.reset();        // ✅ RESET FORM
          this.submitting = false;
        },
        error: () => {
          this.submitting = false;
        }
      });
  }
  openPilPopup() {
    this.showPilPopup = true;
  }
  popupData: string = '';
  displayPopup: boolean = false;
  popupTitle: string = '';
  truncateWords(text: string, wordLimit: number = 30): string {
    if (!text) return '';
    const words = text.split(/\s+/);
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(' ') + ' ...';
  }

  openRemarksPopup(content: string | null | undefined, type: 'remarks' | 'desc') {
    this.popupTitle = type === 'remarks' ? 'Full Remarks' : 'Full Description';
    this.popupData = content ? content : 'No data available';
    this.displayPopup = true;
  }



}